import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import News from './News';

const NewsCollection: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const subLocation = location.pathname.split('/')[2];

  let subPage = <News teaser={false} />;

  if (subLocation === 'benefits') {
    subPage = <News benefits={true} teaser={false} />;
  } else if (subLocation === 'articles') {
    subPage = <News articles={true} teaser={false} />;
  }

  return (
    <>
      <h1 aria-live="polite">
        {!subLocation && t('customerService:news.omaenergiaNewsTitle')}
        {subLocation === 'benefits' && t('header:navigation.benefitsSublink')}
        {subLocation === 'articles' && t('header:navigation.articlesSublink')}
      </h1>
      {subPage}
    </>
  );
};

export default NewsCollection;
